<template>
	<div :id="makeSlug(campaign) + '-packages'">
		<hr class="mt-1 mb-4">

		<!-- Step 2: Package -->
		<h4 class="mb-3">
			<div class="badge badge-danger step">
				{{ $t('donation-form.step') }} 2
			</div>
			{{ $t('donation-form.package_section_title') }}
		</h4>

		<div class="campaign-package">

			<!-- Add more quantity notice -->
			<div class="package-add-more text-13">
				* {{ $t('donation-form.package_section_instructions') }}
			</div>

			<!-- Total for selected campaign -->
			<div class="mt-3 mb-3 text-14">
				{{ campaign }} - <span class="text-bold-500">{{ vueNumberFormat(campaignsTotalDonation(campaign)) }}</span>
			</div>

			<!-- If there is no package -->
			<template v-if="! packages.length">
				<div class="alert alert-warning">
					{{ $t('donation-form.no_packages') }}
				</div>
			</template>

			<!-- Packages -->
			<div class="row pr-3">
				<template v-for="xpackage in packages" :key="xpackage.code">
					<div class="col-3 mb-3 pr-0 d-flex flex-column position-relative mobile-col-3">

						<!-- Package cart count quantity -->
						<span v-if="countPackage(xpackage) && ! xpackage.custom_amount_enabled" class="counter bg-danger text-white align-self-center position-absolute">
							{{ countPackage(xpackage) }}
						</span>

						<!-- Package button -->
						<button type="button" class="btn btn-light border btn-block d-flex flex-column button-package" @click.stop="$emit('donate', xpackage)">
							<div class="lead mb-1">
								{{ xpackage.name }}
							</div>
							<div class="p-0 m-0 h3 amount amount-package" v-bind:class="{'custom-amount': xpackage.custom_amount_enabled}" v-html="xpackage.custom_amount_enabled ? $t('donation-form.custom_amount') : vueNumberFormat(xpackage.amount)"></div>
						</button>
					</div>
				</template>
			</div>
		</div>

		<!-- Quantity & remove quantity icon -->
		<div class="row">
			<div class="col-12">
				<div class="d-flex flex-wrap justify-content-start mt-2">
					<template v-for="donation in donations.filter(donation => donation.campaign === campaign)">
						<template v-for="i in (1, donation.count)">
                            <button v-if="donation.amount * donation.count > 0" type="button" class="btn btn-warning mb-2 mr-2 btn-package-quantity">
								{{ vueNumberFormat(donation.amount) }}
								<span class="quantity-remove" @click.stop="$emit('removeDonation', donation)">
									<i class="fal fa-times-circle text-red ml-1"></i>
					            </span>
							</button>
						</template>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<!-- Scripts -->
<script setup>
import {onMounted} from "vue";
import useHelpers from "@/Composables/UseHelpers";

const { makeSlug, $t } = useHelpers();

const props = defineProps({
	campaign: {
		type: String
	},
	packages: {
		type: Array
	},
	donations: {
		type: Array
	}
});

onMounted(() => {
	let id = makeSlug(props.campaign) + '-packages';

	document.querySelector('#' + id).scrollIntoView({
		behavior: 'smooth'
	});
});

function countPackage(xpackage) {
	if (xpackage.custom_amount_enabled) {
		return props.donations.filter(donation => donation.code === xpackage.code && donation.campaign === xpackage.campaign).length;
	} else {
		let donation = props.donations.find(donation => donation.code === xpackage.code && donation.campaign === xpackage.campaign);

		return donation ? donation.count : 0;
	}
}

function campaignsTotalDonation(campaign) {
	let donations = props.donations.filter(donation => donation.campaign === campaign)
	if (!donations) return 0.00

	return donations.map(donation => donation.amount * donation.count).reduce((prev, next) => prev + next, 0.00);
}
</script>
